var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNvme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4546 80C19.6302 77.1734 16.7462 74.2851 13.8154 71.3542C14.8456 70.422 15.8076 69.3556 15.7012 67.7572C15.6373 66.7951 15.2585 65.965 14.5518 65.2924C12.8981 63.7174 11.1762 63.9643 8.64767 66.097C5.74667 63.1938 2.84992 60.2948 0 57.4405C16.4589 40.9834 33.0135 24.4304 49.4873 7.95831C56.9601 15.4249 64.4989 22.9575 72.0143 30.4667C55.5788 46.8941 39.005 63.4577 22.4546 79.9979V80ZM55.4745 39.9638C59.3844 36.0539 63.1644 32.2716 66.7933 28.6405C61.6405 23.4811 56.4152 18.2494 51.2922 13.1219C47.6016 16.8169 43.8343 20.5843 39.884 24.5389C40.431 24.9668 41.0525 25.4542 41.7868 26.0289C41.0972 26.6653 40.5353 27.1846 39.9713 27.704C40.58 28.3127 41.1525 28.8831 41.8464 29.5749C42.3785 28.9938 42.9085 28.4149 43.3597 27.9232C44.5367 29.1023 45.6541 30.2219 46.9396 31.5118C46.3841 31.9481 45.7626 32.4355 45.3199 32.7846C45.9478 33.521 46.4735 34.1383 47.112 34.8875C47.6718 34.2553 48.1784 33.6828 48.5891 33.2209C49.7534 34.3745 50.8729 35.4813 52.2095 36.8052C51.6455 37.2309 51.0155 37.7034 50.4664 38.1163C51.1177 38.8102 51.6583 39.3849 52.3202 40.0894C52.8438 39.4743 53.3567 38.8741 53.9421 38.1887C54.538 38.8783 55.0403 39.4594 55.4766 39.9638H55.4745ZM23.3357 40.9983C20.7731 43.5545 18.168 46.1534 15.6352 48.6777C20.8327 53.8711 26.0622 59.0965 31.2448 64.2729C33.7883 61.7294 36.3892 59.1305 38.9645 56.5551C33.7734 51.3872 28.5354 46.1725 23.3357 40.9983ZM46.8077 48.7458C41.6165 43.5396 36.3956 38.3015 31.2427 33.1336C29.5464 34.8321 27.8139 36.569 26.1686 38.2164C31.3406 43.3864 36.568 48.6139 41.7591 53.803C43.4235 52.1364 45.1454 50.4124 46.8098 48.7437L46.8077 48.7458ZM33.916 30.29C39.188 35.5473 44.4217 40.7684 49.6023 45.932C50.1173 45.4212 50.692 44.855 51.19 44.3633C45.9776 39.1508 40.7524 33.9233 35.5101 28.6809C35.0057 29.1896 34.4481 29.7515 33.916 30.29ZM13.9112 59.4647C16.0013 59.4498 17.6614 57.7726 17.638 55.6973C17.6146 53.6349 15.9012 51.9513 13.8473 51.9704C11.7679 51.9896 10.1354 53.6626 10.1461 55.7591C10.1588 57.8577 11.8041 59.4796 13.9112 59.4647ZM24.2807 69.8324C26.3708 69.8175 28.031 68.1424 28.0097 66.0693C27.9905 64.0089 26.2729 62.3211 24.2211 62.3424C22.1396 62.3637 20.5071 64.0345 20.5156 66.1289C20.5262 68.2297 22.1715 69.8473 24.2807 69.8324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.535 19.0454C77.7971 20.3012 78.9401 21.4356 80 22.4892C78.0525 24.4602 76.0625 26.4737 74.1086 28.451C66.5975 20.9291 59.0651 13.388 51.5838 5.89794C53.5291 3.95466 55.532 1.95392 57.4858 0C58.516 1.03656 59.6313 2.15825 60.755 3.29059C59.3865 4.61661 57.9285 6.03203 56.4025 7.51343C57.1836 8.15835 57.8093 8.67557 58.4904 9.23748C59.7526 7.94551 61.1892 6.47475 62.5748 5.05507C63.2453 5.70212 63.7923 6.22785 64.4116 6.82594C62.9686 8.25201 61.5213 9.68233 60.1059 11.0807C60.6933 11.6682 61.251 12.228 61.7788 12.7537C63.1644 11.3723 64.6181 9.92071 66.042 8.50103C67.336 9.8079 68.4896 10.9743 69.7049 12.2003C69.2367 12.9176 67.7149 13.6285 69.0154 14.8119C70.1498 15.8463 70.816 14.5224 71.5269 13.9754C72.6315 15.0801 73.6978 16.1443 74.8003 17.249C73.402 18.6367 71.944 20.0841 70.4861 21.5335C71.1586 22.187 71.7248 22.7382 72.374 23.3704C73.751 21.9401 75.177 20.4587 76.5371 19.0433L76.535 19.0454Z",
    fill: "url(#paint0_linear_2_1716)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.405 16.7254C55.2978 20.6162 59.3099 24.6283 63.2687 28.5872C60.7529 31.0797 58.1648 33.6466 55.6107 36.1752C51.7157 32.2929 47.6973 28.285 43.7662 24.3644C46.3054 21.8252 48.8807 19.2497 51.405 16.7254Z",
    fill: "url(#paint1_linear_2_1716)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3824 56.5828C34.0118 57.9343 32.6028 59.3242 31.2406 60.6651C27.286 56.7147 23.2591 52.692 19.2833 48.7224C20.622 47.3836 22.0353 45.9724 23.3932 44.6166C27.3477 48.5649 31.3768 52.5855 35.3803 56.5828H35.3824Z",
    fill: "url(#paint2_linear_2_1716)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6762 38.129C30.1444 37.6544 30.6446 37.1436 31.0597 36.7221C35.1015 40.7662 39.1284 44.7911 43.2 48.8628C42.7978 49.2247 42.2359 49.7312 41.7336 50.1846C37.7684 46.2193 33.7414 42.1944 29.6762 38.129Z",
    fill: "url(#paint3_linear_2_1716)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8537 56.9148C13.1769 56.902 12.6725 56.3678 12.6938 55.6803C12.7129 55.0439 13.3195 54.4862 13.9559 54.5245C14.5497 54.5586 15.1052 55.1503 15.0946 55.7377C15.0818 56.3933 14.5199 56.9275 13.8537 56.9148Z",
    fill: "url(#paint4_linear_2_1716)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2254 67.2931C23.5465 67.2761 23.0399 66.7291 23.0654 66.0459C23.0888 65.4158 23.6295 64.888 24.2509 64.8859C24.8916 64.8859 25.4769 65.4733 25.4684 66.1118C25.462 66.7653 24.8873 67.3102 24.2233 67.2931H24.2254Z",
    fill: "url(#paint5_linear_2_1716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1716",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1716",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1716",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1716",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1716",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1716",
    x1: 24.065,
    y1: 14.2807,
    x2: 53.6417,
    y2: 68.9576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvme);
export default __webpack_public_path__ + "static/media/nvme.f1147ff32b3c5d15528e706f041d06cd.svg";
export { ForwardRef as ReactComponent };